import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
/*global firebaseui*/
/*global firebase*/

Vue.config.productionTip = false
Vue.prototype.$fire_ui = new firebaseui.auth.AuthUI(firebase.auth());

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
